import { transformFunctionsMap } from './transform_functions_map.js';

var stylesSectionsListPerCssSelector = {};

var generateStyles = function generateStyles(selector) {
  var sectionsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var baseStyles = "";
  var ltrStyles = "";
  var rtlStyles = "";
  sectionsList.forEach(function (sections) {
    if (sections.base) {
      baseStyles += sections.base;
    }

    if (sections.ltr) {
      ltrStyles += sections.ltr;
    }

    if (sections.rtl) {
      rtlStyles += sections.rtl;
    }
  });
  var baseCss = baseStyles ? "".concat(selector, "{").concat(baseStyles, "/*|*/}") : "";
  var ltrCss = ltrStyles ? "[dir='ltr'] ".concat(selector, "{").concat(ltrStyles, "/*|*/}") : "";
  var rtlCss = rtlStyles ? "[dir='rtl'] ".concat(selector, "{").concat(rtlStyles, "/*|*/}") : "";
  return "".concat(baseCss).concat(ltrCss).concat(rtlCss);
};

var generateLogicalStyles = function generateLogicalStyles() {
  var logicalStyles = "";
  Object.keys(stylesSectionsListPerCssSelector).forEach(function (selector) {
    var styleSections = stylesSectionsListPerCssSelector[selector];
    logicalStyles = generateStyles(selector, styleSections);
  });
  return logicalStyles;
};

var generateFallbackStyles = function generateFallbackStyles(selector, property, value) {
  if (!transformFunctionsMap[property]) {
    return;
  }

  if (!stylesSectionsListPerCssSelector[selector]) {
    stylesSectionsListPerCssSelector[selector] = [];
  }

  stylesSectionsListPerCssSelector[selector].push(transformFunctionsMap[property](value));
};

var StylisPluginContext = {
  CssSelectorsWithProperties: -2,
  AllProperties: -1,
  Property: 1,
  WebkitProperty: 2,
  AllPseudoSelectors: 3
};

var stylisPluginLogicalCss = function stylisPluginLogicalCss(context, content, cssSelectors) {
  switch (context) {
    case StylisPluginContext.Property:
      var propertyAndValueArray = content.split(":");
      generateFallbackStyles(cssSelectors.join(" "), propertyAndValueArray[0], propertyAndValueArray[1]);
      break;

    case StylisPluginContext.CssSelectorsWithProperties:
      var logicalStyles = generateLogicalStyles();
      var finalStyles = content + logicalStyles;
      finalStyles = finalStyles.replace(/(\r\n|\n|\r)/gm, "");
      stylesSectionsListPerCssSelector = {};
      return finalStyles;
  }
};

Object.defineProperty(stylisPluginLogicalCss, "name", {
  value: "stylisPluginLogicalCss"
});

export { stylisPluginLogicalCss as default };
